<template>
  <div>
    <form id="form_cam">
        <router-link :to="{name: 'listagem-cameras'}" href="#">
          <button class="btn btn-primary btn-micro" id="btn" type="button">
            <i class="fa fa-arrow-left"></i>
          </button>
        </router-link>
        <br><br>
        <div class="row justify-content-center">
            <div class="col-md-3">
              <InputIconGroup typeInput="text" idInput="cam_address" iconInput="fa-file" labelInput="Endereço IP"></InputIconGroup>
            </div>
            <div class="col-md-3">
              <InputIconGroup typeInput="text" idInput="cam_user" iconInput="fa-user" labelInput="Usuário"></InputIconGroup>
            </div>
            <div class="col-md-3">
              <InputIconGroup typeInput="password" idInput="cam_pass" iconInput="fa-lock" labelInput="Senha"></InputIconGroup>
            </div>
            <div class="col-md-3">
              <SelectIconGroup labelInput="Sala" idInput="id_sala" iconInput="fa-info"
                :optionsInput="optionsInput" :optionSelected="optionSelected"></SelectIconGroup>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12 text-center">
                <button class="btn btn-secondary" id="btn_limpar" type="reset">Limpar</button>&nbsp;&nbsp;
                <button class="btn btn-primary" id="btn_salvar" type="submit" @click="salvaInformacoes">Salvar</button>
            </div>
        </div>
    </form>
  </div>
</template>

<script>
import CamsController from './CamsController'
import InputIconGroup from '@/vuestic-theme/vuestic-components/vuestic-input/InputIconGroup'
import SelectIconGroup from '@/vuestic-theme/vuestic-components/vuestic-input/SelectIconGroup'

export default {
  name: 'form-cam',
  components: {
    InputIconGroup,
    SelectIconGroup

  },
  data () {
    return {
      content: {
        load: true
      },
      optionsInput: [{
        id: '',
        value: 'Selecione uma sala'
      }],
      optionSelected: '',
    }
  },
  mounted () {
    let self = this

    if (this.$route.params.idCam) {
      CamsController.carregaFormularioDeEdicao(this.$route.params.idCam)
    }

    CamsController.getSalas(function (data) {
        data.dados.map(function (value) {
            self.optionsInput.push({ id: value.id_sala, value: value.sala })
        })
    })
  },
  methods: {
    salvaInformacoes () {
      if (this.$route.params.idCam) {
        CamsController.update(this.$route.params.idCam)
      } else {
        CamsController.store()
      }
    }
  }
}
</script>
